import PropTypes from "prop-types";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import { addToCart } from "../../store/slices/cart-slice";
import { addToWishlist } from "../../store/slices/wishlist-slice";
import { useTranslation } from "react-i18next";
import ReactStars from "react-rating-stars-component";
import { getCurrencyNameByCountry } from "../../helpers/countryHelper";

const ProductGridSingleSeven = ({
  product,
  currency,
  cartItem,
  wishlistItem,
  compareItem,
  sliderClassName,
  spaceBottomClass,
  colorClass,
}) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const { selectedCountry } = useSelector((state) => state.country);

  const currencyName = getCurrencyNameByCountry(selectedCountry);

  return (
    <Fragment>
      <div
        className={clsx(
          "product-wrap-7 product-card-new h-100",
          spaceBottomClass,
          colorClass
        )}
      >
        <div className="product-card-container">
          <div className="product-img position-relative">
            <Link to={"/product/" + product?.id}>
              <img
                className="default-img rounded-4"
                src={`${import.meta.env.VITE_REACT_APP_API_URL}/${product.img}`}
                alt="product thumb"
                height={"280px"}
                loading="lazy"
              />
              {product?.images?.length ? (
                <img
                  className="hover-img d-md-block d-none rounded-4"
                  src={`${import.meta.env.VITE_REACT_APP_API_URL}/${
                    product?.images?.[0]
                  }`}
                  alt="product thumb"
                  height={"280px"}
                  loading="lazy"
                />
              ) : (
                ""
              )}
            </Link>

            <div className="pro-wishlist-2 position-absolute">
              <button
                className={wishlistItem !== undefined ? "active" : ""}
                disabled={wishlistItem !== undefined}
                title={
                  wishlistItem !== undefined
                    ? t("added_to_wishlist")
                    : t("add_to_wishlist")
                }
                onClick={() => dispatch(addToWishlist(product))}
              >
                <i className="fa fa-heart-o" />
              </button>
            </div>
          </div>

          <div className="product-content-new">
            <h3 className="product-title">
              <Link to={"/product/" + product?.id}>
                {i18n?.language === "ar" ? product?.name : product?.name_en}
              </Link>
            </h3>

            {product?.rating_avg ? (
              <div className="product-rating-new mb-2">
                <ReactStars
                  count={5}
                  value={Number(product?.rating_avg)}
                  size={20}
                  edit={false}
                  activeColor="#ffd700"
                />
              </div>
            ) : (
              ""
            )}
            {product?.description && (
              <p
                className="product-description"
                dangerouslySetInnerHTML={{
                  __html:
                    i18n?.language === "ar"
                      ? product?.description
                      : product?.description_en,
                }}
              ></p>
            )}

            {product?.variants && product?.variants?.length > 0 && (
              <div className="product-variants mb-3">
                {product?.variants?.map((variant, index) => (
                  <button key={index} className="variant-btn" title={variant}>
                    {variant}
                  </button>
                ))}
              </div>
            )}

            <div className="product-footer d-flex align-items-center justify-content-between">
              <div className="product-price">
                {product?.discount ? (
                  <Fragment>
                    <span className="price-current fw-bold">
                      {Number(
                        product?.price -
                          product?.price * (product?.discount / 100)
                      )?.toFixed(2)}{" "}
                      <span className="currency">{currencyName}</span>
                    </span>
                  </Fragment>
                ) : (
                  <span className="price-current fw-bold">
                    {Number(product?.price)?.toFixed(2)}{" "}
                    <span className="currency">{currencyName}</span>
                  </span>
                )}
              </div>

              {product?.quantity ? (
                <button
                  onClick={() => dispatch(addToCart(product))}
                  className={
                    cartItem !== undefined && cartItem.quantity > 0
                      ? "add-to-cart-btn active"
                      : "add-to-cart-btn"
                  }
                  disabled={cartItem !== undefined && cartItem.quantity > 0}
                  title={
                    cartItem !== undefined
                      ? t("item_added_to_cart")
                      : t("add_to_cart")
                  }
                >
                  <i className="fa fa-shopping-cart me-2"></i>
                  {cartItem !== undefined
                    ? t("item_added_to_cart")
                    : t("add_to_cart")}
                </button>
              ) : (
                <button
                  disabled
                  className="add-to-cart-btn active out-of-stock"
                  title={t("out_of_stock")}
                >
                  <i className="fa fa-shopping-cart me-2"></i>
                  {t("out_of_stock")}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* product modal */}
    </Fragment>
  );
};

ProductGridSingleSeven.propTypes = {
  cartItem: PropTypes.shape({}),
  compareItem: PropTypes.shape({}),
  currency: PropTypes.shape({}),
  product: PropTypes.shape({}),
  spaceBottomClass: PropTypes.string,
  colorClass: PropTypes.string,
  wishlistItem: PropTypes.shape({}),
};

export default ProductGridSingleSeven;
